<template>
  <div data-app>
    <v-container>
      <v-row>
        <v-col cols="2" class="pt-5">
          <v-select
            v-model="searchOption"
            :items="searchOptions"
            item-text="text"
            item-value="id"
            label="giáo viên"
            solo
          ></v-select>
        </v-col>
        <v-col cols="6" class="pt-7">
          <HnrInput
            :name="'title'"
            v-model="key_search"
            :text="key_search"
            :label="'Nhập title slider'"
          ></HnrInput>
        </v-col>
        <v-col cols="1">
          <HnrButton
            :width="100"
            @hnrClickEvent="getSearchResult"
            :text="buttonText"
            :color="buttonColor"
            :height="40"
            :outlined="true"
          ></HnrButton>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <template>
      <v-data-table
        :headers="headers"
        :items="teachers"
        class="elevation-1"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :server-items-length="total"
        @update:items-per-page="updateItemPerPage"
        @update:page="updatePage"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-card-title>
              {{ lang.listTeacher }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="getDetail(item.id)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item, item.id)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.isDisplay="{ item }">
          <v-checkbox
              v-model="item.is_teacher"
              color="success"
              v-on:click="updateUser(item.id, item.is_teacher)"
              :value="item.is_teacher"
              hide-details
              class="mb-6"
          ></v-checkbox>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </template>
    <updateUserInfo :dialog="dialog" :id="user_id"></updateUserInfo>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import {
  GET_USER_INFO,
  GET_LIST_TEACHER,
  COUNT_TEACHER,
  GET_TEACHER_SEARCH_RESULT,
  DELETE_USER
} from "@/store/user.module";
import { validationMixin } from "vuelidate";
import HnrButton from "@/components/elements/hnr-button";
import HnrInput from "@/components/elements/hnr-input";
import updateUserInfo from "../../../../components/user/updateUserInfo";

export default {
  mixins: [validationMixin],
  components: {
    HnrButton,
    HnrInput,
    updateUserInfo
  },
  data: () => ({
    lang: {
      listTeacher: "Danh sách giáo viên"
    },
    buttonText: "Tìm kiếm",
    buttonColor: "primary",
    searchOptions: [
      { text: "Giáo viên", id: 1 },
      { text: "Học viên", id: 0 }
    ],
    searchOption: 1,
    key_search: "",
    user_id: "",
    dialog: false,
    search: "",
    page: 1,
    itemsPerPage: 10,
    headers: [
      {
        text: "id",
        align: "start",
        sortable: false,
        value: "id"
      },
      { text: "Tên", value: "full_name" },
      { text: "Email", value: "email" },
      { text: "Số điện thoại", value: "phone_number" },
      { text: "Hành động", value: "actions", sortable: false },
      { text: "Hiển thị trên trang trủ", value: "isDisplay", sortable: false }
    ],
    image: {},
    editedIndex: -1,
    editedItem: {
      id: "",
      title: "loremislum",
      content: "heyasfasfa",
      author: "jobert",
      created_date: "2020-09-08"
    },
    defaultItem: {
      id: "",
      title: "loremislum",
      content: "heyasfasfa",
      author: "jobert",
      created_date: "2020-09-08"
    },
    url: null
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    teachers() {
      return this.$store.getters.listTeachers;
    },
    total() {
      return this.$store.getters.teacherCount;
    },
    submitTypeName() {
      return this.editedIndex === -1 ? "Save" : "Update";
    }
  },
  mounted() {
    this.count();
    this.getTeachers();
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created () {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Giáo viên",titledad:'Người dùng' }]);
  },

  methods: {
    getTeachers() {
      var payload = { page: this.page, page_count: this.itemsPerPage };
      this.$store.dispatch(GET_LIST_TEACHER, payload);
    },
    count() {
      this.$store.dispatch(COUNT_TEACHER);
    },
    updateItemPerPage($event) {
      this.itemsPerPage = $event;
      this.getTeachers();
    },

    updatePage($event) {
      this.page = $event;
      this.getTeachers();
    },

    editItem(item, user_id) {
      this.$store.dispatch(GET_USER_INFO, { id: user_id });
      this.dialog = !this.dialog;
      this.editedIndex = this.teachers.indexOf(item);
      this.user_id = user_id;
      // this.url = item.images[0].src;
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
    },
    getSearchResult() {
      var payload = { key_search: this.key_search };
      this.$store.dispatch(GET_TEACHER_SEARCH_RESULT, payload);
    },
    async deleteItem(item, user_id) {
      if (confirm("are you sure?")) {
        await this.$store.dispatch(DELETE_USER, { id: user_id });
        this.editedIndex = this.students.indexOf(item);
        this.students.splice(this.editedIndex, 1);
      }
    },
    getDetail(user_id) {
      this.$router.push({
        path: "/user/teacher/" + user_id + "/info"
      });
    }
  }
};
</script>
<style>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}
</style>
